
// import { Component, OnInit, VERSION } from '@angular/core';
// import { FormBuilder, ReactiveFormsModule, FormsModule, NgControl, FormGroup } from '@angular/forms';

import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbModal, NgbDateStruct, NgbDate, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from "@angular/router";
import { FormApiService } from '../../shared/services/form-api.service';


@Component({
  selector: 'app-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.css']
})
export class MakePaymentComponent implements OnInit {

  Form = new FormGroup({
    name: new FormControl(),
    email: new FormControl(),
    number: new FormControl(),
    detail: new FormControl(),
  });

  returnUrl: string;

  constructor(private formBuilder: FormBuilder, private calendar: NgbCalendar,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private http: HttpClient, private route: ActivatedRoute, private router: Router,
    private renderer: Renderer2, el: ElementRef,
    private _FormApiService: FormApiService,
  ) {

  }

  ngOnInit(): void {

  }

  Create(){
    console.log("FORM");

    var obj = {
      cinco_subject: "Make a Payment Form",
      cinco_addToName: this.Form.get('name').value,
      cinco_addToEmail: this.Form.get('email').value,
      cinco_number: this.Form.get('number').value,
      cinco_template: this.Form.get('detail').value,
    }
   // console.log(obj);

    this._FormApiService.insertFormData(obj)
        .subscribe(response => {
         // console.log(response);
         alert('Form has been submited.');
         this.Form.get('name').reset()
         this.Form.get('email').reset()
         this.Form.get('number').reset()
         this.Form.get('detail').reset()

        });
  }


  

}



/*
import { Component, EventEmitter } from '@angular/core';
import {FormBuilder, ReactiveFormsModule, FormsModule, NgControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'make-payment.component',
  templateUrl: './make-payment.component.html'
})
export class MakePaymentComponent {
    form: FormGroup;
   constructor(fb:FormBuilder) {
    this.form=fb.group({
      phone:['']
    })
  }

}
*/
